import { apiUrlOriginacao, enableApiMocks } from "@settings";

export const enableMocking = async () => {
  if (!enableApiMocks) return;

  const { worker } = await import("./browser");
  return worker.start({
    onUnhandledRequest(req, print) {
      if (!req.url.includes(apiUrlOriginacao)) return;
      print.warning();
    },
  });
};
